export const isAppActive = (app) => {
    return Boolean(app && app.account_feature && app.account_feature.status === 'active')
};

export default {
    isAppActive
}